import { createContext, useContext, useState } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');
  const t = (key) => {
    const byLang = translations[lang]?.[key];
    if (byLang !== undefined) return byLang;
    const byEn = translations.en?.[key];
    if (byEn !== undefined) return byEn;
    return '';
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
